module.exports = __webpack_public_path__ + "static/img/logo.fc67fc69.png";